import { Provider } from '@angular/core';
import { NotificationService } from './notification.service';
import { NotificationSenderService } from './NotificationSenderService';
import { NotificationReceiverService } from './NotificationReceiverService';

export const notificationProviders: Provider[] = [
    { provide: NotificationSenderService, useClass: NotificationService },
    { provide: NotificationReceiverService, useExisting: NotificationSenderService }
];
